// import Vue from 'vue';
import router from '@/router/router';

window.handleGoTo = function(toLink) {
    router.push({
        name: toLink
    });
}